const wideKeywords = [
    'Warning(message)',
    'Values(identifierName, useDefault, defaultValue)',
    'Values(identifierName, useDefault)',
    'Values(identifierName, span, useDefault, defaultValue)',
    'Values(identifierName, span, useDefault)',
    'Values(identifierName, span, defaultValue)',
    'Values(identifierName, span)',
    'Values(identifierName, groupName, useDefault, defaultValue)',
    'Values(identifierName, groupName, useDefault)',
    'Values(identifierName, groupName, span, useDefault, defaultValue)',
    'Values(identifierName, groupName, span, useDefault)',
    'Values(identifierName, groupName, span, defaultValue)',
    'Values(identifierName, groupName, span)',
    'Values(identifierName, groupName, defaultValue)',
    'Values(identifierName, groupName)',
    'Values(identifierName, defaultValue)',
    'Values(identifierName)',
    'UpdateLogbookEntry(logbookEntryId, beginDateTime, endDateTime, isInProgress, severity, comment, categories, groupName, identifierName)',
    'TriggerAlarm(identifierName, severity)',
    'TriggerAlarm(identifierName, severity, alarmType)',
    'TriggerAlarm(identifierName, severity, valueType)',
    'TriggerAlarm(identifierName, severity, alarmType, valueType)',
    'ToPosix(dateTime)',
    'SetValue(identifierName, value)',
    'SetValue(identifierName, value, status)',
    'SetTargetValue(identifierName, value, deviation, relativeDeviation)',
    'SetTargetValue(identifierName, value)',
    'SetState(stateName)',
    'SetReconciledValue(identifierName, groupName, measuredValue, value, resolution)',
    'SetReconciledValue(identifierName, groupName, measuredValue, value)',
    'SetReconciledInternalValue(identifierName, groupName, measuredValue, value, resolution)',
    'SetReconciledInternalValue(identifierName, groupName, measuredValue, value)',
    'SetInternalValue(identifierName, value)',
    'SetInternalValue(identifierName, value, status)',
    'SetInternalTargetValue(identifierName, value, deviation, relativeDeviation)',
    'SetInternalTargetValue(identifierName, value)',
    'SetGlobal(key, value)',
    'ResetIncidence()',
    'RemoveIncidence(identifierName, nSpan)',
    'RemoveIncidence(identifierName, groupName, nSpan)',
    'RemoveIncidence(identifierName, groupName)',
    'RemoveIncidence(identifierName)',
    'PresetValidatedValue(identifierName, value, comment)',
    'PresetValidatedValue(identifierName, identifier)',
    'PresetInternalValidatedValue(identifierName, value, comment)',
    'PresetInternalValidatedValue(identifierName, identifier)',
    'PresetSpotInternalValue(identifierName, timeStamp, value, comment)',
    'PresetSpotInternalValue(identifierName, timeStamp, value)',
    'PresetSpotValue(identifierName, timeStamp, value, comment)',
    'PresetSpotValue(identifierName, timeStamp, value)',
    'Parameter(parameterName, groupName)',
    'Parameter(parameterName, group)',
    'Parameter(parameterName)',
    'Meta(identifierName, groupName)',
    'Meta(identifierName)',
    'InternalValues(identifierName, useDefault, defaultValue)',
    'InternalValues(identifierName, useDefault)',
    'InternalValues(identifierName, span, useDefault, defaultValue)',
    'InternalValues(identifierName, span, useDefault)',
    'InternalValues(identifierName, span, defaultValue)',
    'InternalValues(identifierName, span)',
    'InternalValues(identifierName, groupName, useDefault, defaultValue)',
    'InternalValues(identifierName, groupName, useDefault)',
    'InternalValues(identifierName, groupName, span, useDefault, defaultValue)',
    'InternalValues(identifierName, groupName, span, useDefault)',
    'InternalValues(identifierName, groupName, span, defaultValue)',
    'InternalValues(identifierName, groupName, span)',
    'InternalValues(identifierName, groupName, defaultValue)',
    'InternalValues(identifierName, groupName)',
    'InternalValues(identifierName, defaultValue)',
    'InternalValues(identifierName)',
    'InternalMeta(identifierName, groupName)',
    'InternalMeta(identifierName)',
    'IdentifierList(searchString, startingPoint, includeChildren)',
    'IdentifierList(searchString, startingPoint)',
    'IdentifierList(searchString)',
    'IdentifierList()',
    'Identifier(identifierName, nSpan)',
    'Identifier(identifierName, groupName, nSpan)',
    'Identifier(identifierName, groupName)',
    'Identifier(identifierName, group)',
    'Identifier(identifierName)',
    'GroupList(searchString)',
    'GroupList()',
    'Group(groupName)',
    'Group()',
    'Globals',
    'GetValues(identifierName, valueType)',
    'GetValues(identifierName, groupName, valueType)',
    'GetValues(identifierName, valueType, endDateTime)',
    'GetValues(identifierName, groupName, valueType, endDateTime)',
    'GetValues(identifierName, valueType, beginDateTime, endDateTime)',
    'GetValues(identifierName, groupName, valueType, beginDateTime, endDateTime)',
    'GetStampedValues(identifierName, valueType, beginDateTime, endDateTime)',
    'GetStampedValues(identifierName, groupName, valueType, beginDateTime, endDateTime)',
    'GetStampedInternalValues(identifierName, valueType, beginDateTime, endDateTime)',
    'GetStampedInternalValues(identifierName, groupName, valueType, beginDateTime, endDateTime)',
    'GetSpot(identifierName)',
    'GetSpot(identifierName, timeStamp)',
    'GetSpot(identifierName, groupName)',
    'GetSpot(identifierName, groupName, timeStamp)',
    'GetPeriodValue(identifierName, groupName, valueType, min, max, maxGroupSpan)',
    'GetPeriodInternalValue(identifierName, groupName, valueType, min, max, maxGroupSpan)',
    'GetMinMaxDates()',
    'GetLogbook(groupSearchString, includeChildren, identifierName, beginDate, endDate)',
    'GetInternalValues(identifierName, valueType)',
    'GetInternalValues(identifierName, groupName, valueType)',
    'GetInternalValues(identifierName, valueType, endDateTime)',
    'GetInternalValues(identifierName, groupName, valueType, endDateTime)',
    'GetInternalValues(identifierName, valueType, beginDateTime, endDateTime)',
    'GetInternalValues(identifierName, groupName, valueType, beginDateTime, endDateTime)',
    'GetInternalSpot(identifierName)',
    'GetInternalSpot(identifierName, timeStamp)',
    'GetInternalSpot(identifierName, groupName)',
    'GetInternalSpot(identifierName, groupName, timeStamp)',
    'GetHistorianValues(identifierName, intervalInSeconds, beginDate, endDate)',
    'GetHistorianValues(identifierName, groupName, intervalInSeconds, beginDateTime, endDateTime)',
    'GetHistorianInternalValues(identifierName, intervalInSeconds, beginDateTime, endDateTime)',
    'GetHistorianInternalValues(identifierName, groupName, intervalInSeconds, beginDateTime, endDateTime)',
    'GetGlobal(key)',
    'GetCurrentType()',
    'FromPosix(posixSeconds)',
    'Exit()',
    'Error(message)',
    'DeleteLogbookEntry(logbookEntryId)',
    'CurrentTimeStamp()',
    'CurrentTimestamp()',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment, category, groupName, identifierName, updateExisting)',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment, category, groupName, identifierName)',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment, category, groupName)',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment, category)',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment, categories, groupName, identifierName, updateExisting)',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment, categories, groupName, identifierName)',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment, categories, groupName)',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment, categories)',
    'CreateLogbookEntry(beginDateTime, endDateTime, severity, comment)',
    'ConvertToUTC(localDate)',
    'ConvertToString(value, identifierName, groupName)',
    'ConvertToString(value, identifierName)',
    'ConvertFromString(string, identifierName, groupName)',
    'ConvertFromString(string, identifierName)',
    'ConvertToInternal(value, sourceUnitName, variableTypeName)',
    'ConvertToInternal(value, sourceUnitName, variableType)',
    'ConvertFromUTC(utcDate)',
    'ConvertFromInternal(value, targetUnitName, variableTypeName)',
    'ConvertFromInternal(value, targetUnitName, variableType)',
    'Convert(value, sourceUnitName, targetUnitName, variableTypeName)',
    'Convert(value, sourceUnit, targetUnitName, variableType)',
    'Convert(scriptIdentifier, targetUnitName)',
    'BestModel(modelName, url)',
    'BestModel(modelName)',
    'ApplicationContentPath',
    'Application()',
    'AddIncidence(identifierName, nSpan)',
    'AddIncidence(identifierName, groupName, nSpan)',
    'AddIncidence(identifierName, groupName)',
    'AddIncidence(identifierName)'
];

const thermoKeywords = [
    'Composition(packageName)',
    'CalcMolecularWeight(packageName, composition)',
    'CalcMolecularWeight(packageName)',
    'CalcHV(packageName, temperature, pressure, compounds)',
    'CalcHV(packageName, temperature, pressure, composition)',
    'CalcHV(packageName, temperature, pressure)',
    'CalcHL(packageName, temperature, pressure, compounds)',
    'CalcHL(packageName, temperature, pressure, composition)',
    'CalcHL(packageName, temperature, pressure)',
    'CalcFlashWT(packageName, vaporFraction, temperature, compounds)',
    'CalcFlashWT(packageName, vaporFraction, temperature, composition)',
    'CalcFlashWT(packageName, vaporFraction, temperature)',
    'CalcFlashWP(packageName, vaporFraction, pressure, compounds)',
    'CalcFlashWP(packageName, vaporFraction, pressure, composition)',
    'CalcFlashWP(packageName, vaporFraction, pressure)',
    'CalcFlashTP(packageName, temperature, pressure, compounds)',
    'CalcFlashTP(packageName, temperature, pressure, composition)',
    'CalcFlashTP(packageName, temperature, pressure)',
    'CalcFlashLLVWP(packageName, vaporFraction, pressure, compounds)',
    'CalcFlashLLVWP(packageName, vaporFraction, pressure, composition)',
    'CalcFlashLLVWP(packageName, vaporFraction, pressure)',
    'CalcFlashLLVTP(packageName, temperature, pressure, compounds)',
    'CalcFlashLLVTP(packageName, temperature, pressure, composition)',
    'CalcFlashLLVTP(packageName, temperature, pressure)',
    'CalcFlashLLVHP(packageName, enthalpy, pressure, compounds)',
    'CalcFlashLLVHP(packageName, enthalpy, pressure, composition)',
    'CalcFlashLLVHP(packageName, enthalpy, pressure)',
    'CalcFlashHP(packageName, enthalpy, pressure, compounds)',
    'CalcFlashHP(packageName, enthalpy, pressure, composition)',
    'CalcFlashHP(packageName, enthalpy, pressure)',
    'CalcDewTemperature(packageName, pressure, compounds)',
    'CalcDewTemperature(packageName, pressure, composition)',
    'CalcDewTemperature(packageName, pressure)',
    'CalcDewPressure(packageName, temperature, compounds)',
    'CalcDewPressure(packageName, temperature, composition)',
    'CalcDewPressure(packageName, temperature)',
    'CalcDensityV(packageName, temperature, pressure, compounds)',
    'CalcDensityV(packageName, temperature, pressure, composition)',
    'CalcDensityV(packageName, temperature, pressure)',
    'CalcDensityL(packageName, temperature, pressure, compounds)',
    'CalcDensityL(packageName, temperature, pressure, composition)',
    'CalcDensityL(packageName, temperature, pressure)',
    'CalcCompressibilityAGA8(t, p, composition)',
    'CalcBubbleTemperature(packageName, pressure, compounds)',
    'CalcBubbleTemperature(packageName, pressure, composition)',
    'CalcBubbleTemperature(packageName, pressure)',
    'CalcBubblePressure(packageName, temperature, compounds)',
    'CalcBubblePressure(packageName, temperature, composition)',
    'CalcBubblePressure(packageName, temperature)',
    'GetDefaultMolarComposition(packageName)',
    'ConvertToMolarFractions(packageName, composition)',
    'ConvertToMassFractions(packageName, composition)'
];

const AGAKeywords = [
    'AgaAPI.CalcCompressibilityAGA8(temperature , pression , composition)',
    'AgaAPI.Detail.CalcMolarMass(composition)',
    'AgaAPI.Detail.CalcMolarDensity(temperature, pression, composition)',
    'AgaAPI.Detail.CalcPressure(temperature, molarDensity, composition)',
    'AgaAPI.Detail.CalcProperties(temperature, molarDensity, composition)',
    'AgaAPI.GERG2008.CalcMolarMass(composition)',
    'AgaAPI.GERG2008.CalcMolarDensity(temperature, pression, composition)',
    'AgaAPI.GERG2008.CalcPressure(temperature, molarDensity, composition)',
    'AgaAPI.GERG2008.CalcProperties(temperature, molarDensity, composition)'
];

const rootKeywords = ['Quality.Suspicious', 'Quality.Scattered', 'Quality.OutOfRange', 'Quality.Missing', 'Quality.Invalid', 'Quality.Flat', 'Quality.Bad'];

export const v3scriptKeywords = rootKeywords
    .concat(wideKeywords)
    .concat(wideKeywords.map((k) => `wide.${k}`))
    .concat(thermoKeywords.map((k) => `Thermo.${k}`))
    .concat(AGAKeywords)
    .sort((a, b) => -a.localeCompare(b, 'en'));

//anti-alphabetical order due to code mirror behaviour
export const v2scriptKeywords = rootKeywords
    .concat(thermoKeywords)
    .concat(AGAKeywords)
    .concat(wideKeywords)
    .sort((a, b) => -a.localeCompare(b, 'en'));
